import { VisibilityState } from '@tanstack/react-table';
import { TableColumn } from '../models';

/**
 * Returns the visibility state of columns to be passed to TanStack table
 *
 * As of TanStack v8, columns are visibile by default, so only colDefs need to be taken as input
 * See https://github.com/TanStack/table/blob/main/packages/table-core/src/features/Visibility.ts#L175
 *
 * @param colDefs
 * @returns an object mapping column names to a boolean representing whether the column should be visible
 */
export const getColumnVisibilityState = (colDefs: TableColumn[]): VisibilityState => {
  return (
    colDefs?.reduce((acc, colDef) => {
      acc[colDef.field] = !colDef.hidden;
      return acc;
    }, {} as VisibilityState) ?? {}
  );
};
